import '@/app/app.css';
import './portfolio-project.css';

import '@/app/app';

import { Gallery } from '@/features/gallery/gallery';

window.addEventListener('DOMContentLoaded', () => {
	const tabs = document.querySelector('.js-portfolio-project__tabs');
	if (!tabs) return;

	const galleryInstances = new WeakMap();

	const initGalleries = (container) => {
		const galleries = container.querySelectorAll('.js-gallery');
		if (!galleries.length) return;

		galleries.forEach((gallery) => {
			if (galleryInstances.has(gallery)) return;
			const instance = new Gallery(gallery);
			galleryInstances.set(gallery, instance);
		});
	};

	const destroyGalleries = (container) => {
		const galleries = container.querySelectorAll('.js-gallery');
		if (!galleries.length) return;

		galleries.forEach((gallery) => {
			const instance = galleryInstances.get(gallery);
			if (instance) {
				instance.destroy();
				galleryInstances.delete(gallery);
			}
		});
	};

	const activeTabContent = tabs.querySelector('.js-tabs__content.tabs__content--active');
	if (activeTabContent) initGalleries(activeTabContent);

	tabs.querySelectorAll('.js-tabs__content').forEach((content) => {
		content.addEventListener('tabShown', () => {
			tabs.querySelectorAll('.js-tabs__content').forEach((tab) => {
				if (tab !== content) destroyGalleries(tab);
			});
			initGalleries(content);
		});
	});
});
